import AccountDetailsPage, { getDefaultPageUI } from "components/pages/AccountDetailsPage";
import { BCMSStateManagerCRUD } from "bcms-react";
import { getTransactionAccordionConfig } from "components/custom-ui/CustomTransactionAccordion";

export default function CaptureAccountsViewCheckImage(props) {
    const { key, value } = getTransactionAccordionConfig("2");

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ key ], { ...value, accordionActive: true, showChecks: true })
        .submit();

    return <AccountDetailsPage ui={ ui } />
}